import { useDispatch, useSelector } from "react-redux";
import CustomCommandBar from "../../Components/CustomCommandBar/CustomCommandBar";
import Loadable from "../../Components/Loadable/Loadable";
import NavigationMenu from "../../Components/NavigationMenu/NavigationMenu";
import { ISentinelRich } from "../../Models/ISentinel";
import "./LandingPage.scss";
import { useEffect, useState } from "react";
import { GlobalState } from "../../Redux/RootReducer";
import ApiService from "../../Services/ApiService";
import { GenericActions } from "../../Redux/Generic/GenericAction";
import { ToastMessage } from "../../Utils/UIMessages";
import { IAPIResponse } from "../../Services/AjaxService";
import MonitoringCardSmartBed from "../../Components/MonitoringCardSmartBed/MonitoringCardSmartBed";
import MonitoringCardGateway from "../../Components/MonitoringCardGateway/MonitoringCardGateway";

const LandingPage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const sentinels: ISentinelRich[] = useSelector(
    (s: GlobalState) => s.generic.sentinels || []
  );

  const loadSentinels = () => {
    if (sentinels.length === 0) {
      setLoading(true);
    }
    ApiService.SentinelController.GetSentinels((response: IAPIResponse) => {
      if (response.error === null) {
        dispatch(GenericActions.setSentinels(response.parsed) as any);
      } else {
        ToastMessage("error", "Impossibile caricare le Letti.");
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    loadSentinels();
  }, []);

  // Filter sentinels for enabled and valid bed
  const filteredSentinels = (sentinels ?? []).filter(
    (x: ISentinelRich) => x.enabled && x.patient.bed !== "0"
  );

  // Get unique floors (corridors)
  const uniqueFloors = Array.from(
    new Set(filteredSentinels.map((x: ISentinelRich) => x.patient.floor))
  ).sort(); // Sort for consistent display order

  // Group sentinels by floor
  const groupedSentinels = uniqueFloors.reduce(
    (acc: { [key: string]: ISentinelRich[] }, floor) => {
      acc[floor] = filteredSentinels.filter(
        (x: ISentinelRich) => x.patient.floor === floor
      );
      return acc;
    },
    {}
  );

  return (
    <div className="fade-in-whole-page">
      <CustomCommandBar
        specials={[
          <div className="command-bar-title">Home</div>,
          <NavigationMenu />,
        ]}
        buttons={[]}
      />
      <div className="sliding-page-content">
        <Loadable
          content={
            <div className="monitoring-columns">
              {uniqueFloors.map((floor) => (
                <div className="floor-column" key={floor}>
                  <h2>{floor}</h2>
                  {groupedSentinels[floor]
                    .sort((x: ISentinelRich, y: ISentinelRich) => {
                      return x.id - y.id;
                    })
                    .map((x: ISentinelRich, i: number) => {
                      // Check if sentinel is a gateway (varco) or a bed (letto)
                      const isGateway = x.identifier.toLowerCase().includes("varco");
                      
                      return isGateway ? (
                        <MonitoringCardGateway
                          index={i}
                          sentinel={x}
                          key={x.id}
                        />
                      ) : (
                        <MonitoringCardSmartBed
                          index={i}
                          sentinel={x}
                          key={x.id}
                        />
                      );
                    })}
                </div>
              ))}
            </div>
          }
          isLoading={loading}
        />
      </div>
    </div>
  );
};

export default LandingPage;
